<div class="auth-form" [class.auth-form--parent]="isParentLayout()">
  @if (mode() === 'signin') {
    <form [formGroup]="signinForm">
      <app-input-field
        formControlName="userName"
        [label]="'app.auth.userName' | translate"
        [inputType]="'input'"
        [type]="'text'"
        [autocomplete]="'username'"
        [validationErrors]="userNameValidation()"
        (keydown.enter)="onSubmit()"
      />

      <app-input-field
        formControlName="password"
        [label]="'app.auth.password' | translate"
        [inputType]="'input'"
        [type]="'password'"
        [autocomplete]="'current-password'"
        [validationErrors]="passwordValidation()"
        (keydown.enter)="onSubmit()"
      />

      <button
        type="button"
        class="auth-form__link"
        (click)="onForgotPasswordClick()"
      >
        {{ 'app.auth.forgotPassword' | translate }}
      </button>

      <div class="auth-form__cta">
        @if (isParentLayout()) {
          <app-parent-button
            [fullWidth]="true"
            [loading]="isLoading()"
            [disabled]="!signinForm.valid"
            (clicked)="onSubmit()"
          >
            {{ 'app.auth.signIn' | translate }}
          </app-parent-button>
        } @else {
          <app-cta-button
            [loading]="isLoading()"
            [disabled]="!signinForm.valid"
            (clicked)="onSubmit()"
            (keydown.enter)="onSubmit()"
            size="small"
          >
            <span cta-label>{{ 'app.auth.signIn' | translate }}</span>
          </app-cta-button>
        }
      </div>
    </form>
  }

  @if (mode() === 'forgot') {
    <app-forgot-password-request
      [isEmbedded]="true"
      [layout]="layout()"
      (requested)="onResetRequested($event)"
      (back)="onResetBack()"
    />
  }

  @if (mode() === 'update') {
    <app-update-password
      [isEmbedded]="true"
      [layout]="layout()"
      [initialUserName]="resetUserName()"
      (updated)="onPasswordUpdated()"
      (back)="onResetBack()"
    />
  }
</div>
